$(document).ready(function(){
  $(".select_box_title").click(function(){
    $(this).next().slideToggle(200);
    $(this).find("i.fas.fa-caret-down").toggleClass("rotate_caret");
  });
});



// WEBPACK FOOTER //
// app/frontend/javascripts/select_box.js